
import Vue from 'vue'

export default Vue.extend({
  name: 'ChefBookVatInvoice',
  props: {
    form: {
      type: Object,
      required: true
    }
  },
})
